import {ReactNode} from "react";

import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";
import {useGetPlannerInvestmentDataQuery} from "../api/fetch_investment_planner_details";
import {Planner3DImakeable} from "./Planner3DImakeable";

interface Props {
    className?: string;
    children: ReactNode;
    // routedModalId has to be unique across entire view
    routedModalId: string;
    offer: IMakeablePlansOffer;
    initialBuildingUuid?: string | null;
    initialFloor?: number | null;
}

export const Planner3dModal = (props: Props) => {
    const {data: investmentData} = useGetPlannerInvestmentDataQuery({investmentUuid: props.offer.uuid});

    // Render planner only when all SVG plans are drawn:
    // - investment is_ready === true (all estates in investment are marked as ready in P2D)
    // - show_floors_navigator === true (checkbox in PH is selected)
    if (investmentData?.is_ready && props.offer.configuration.show_floors_navigator) {
        return (
            <Planner3DImakeable
                offer={props.offer}
                modalId={props.routedModalId}
                initialBuildingUuid={props.initialBuildingUuid}
                initialFloor={props.initialFloor}
                className={props.className}
            >
                {props.children}
            </Planner3DImakeable>
        );
    }

    return null;
};
import {ReactNode} from "react";

import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";
import {useGetPlannerInvestmentDataQuery} from "../api/fetch_investment_planner_details";
import {Planner3DImakeable} from "./Planner3DImakeable";

interface Props {
    className?: string;
    children: ReactNode;
    // routedModalId has to be unique across entire view
    routedModalId: string;
    offer: IMakeablePlansOffer;
    initialBuildingUuid?: string | null;
    initialFloor?: number | null;
}

export const Planner3dModal = (props: Props) => {
    const {data: investmentData} = useGetPlannerInvestmentDataQuery({investmentUuid: props.offer.uuid});

    // Render planner only when all SVG plans are drawn:
    // - investment is_ready === true (all estates in investment are marked as ready in P2D)
    // - show_floors_navigator === true (checkbox in PH is selected)
    if (investmentData?.is_ready && props.offer.configuration.show_floors_navigator) {
        return (
            <Planner3DImakeable
                offer={props.offer}
                modalId={props.routedModalId}
                initialBuildingUuid={props.initialBuildingUuid}
                initialFloor={props.initialFloor}
                className={props.className}
            >
                {props.children}
            </Planner3DImakeable>
        );
    }

    return null;
};
